import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { Laboratory } from '@medprev-web-app/api-graphql-client';

import { BranchLaboratoryAddress } from './branch-laboratory-address.component';
import BranchLaboratoryStructure from './branch-laboratory-structure.component';

import { EntitySection } from '@/app/(main)/(pages)/_components/entities/entity-section.component';
import { EntitySectionDivider } from '@/app/(main)/(pages)/_components/entities/entity-section-divider.component';
import { EntityAbout } from '@/app/(main)/(pages)/_components/entities/entity-about.component';
import {
  GalleryCarousel,
  GalleryImage,
} from '@/app/(main)/(pages)/_components/entities/gallery-carousel/gallery-carousel.component';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface BranchLaboratoryAboutSectionProps {
  laboratory: Laboratory;
}

export function BranchLaboratoryAboutSection({ laboratory }: BranchLaboratoryAboutSectionProps) {
  const { structure } = laboratory;

  const hasStructure
    = structure?.airConditioning
      || structure?.elevator
      || structure?.parking
      || structure?.specialAccess;

  const hasGalleryImages = !!laboratory?.facilityImages?.length;

  return (
    <>
      <EntitySection
        data-testid={DataTestIdEnum.LABORATORY_PROFILE_SECTION_ADDRESS}
        title="Endereço"
        id="address"
        className="my-0 py-4"
        titleStyles="mb-4 leading-6"
        removeHr
      >
        <BranchLaboratoryAddress laboratory={laboratory} />
      </EntitySection>

      {laboratory.description && (
        <>
          <EntitySectionDivider />

          <EntitySection
            title="Sobre o local"
            id="about-place"
            className="my-0 py-4"
            titleStyles="leading-6"
            removeHr
          >
            <EntityAbout
              description={laboratory.description}
              analyticsEvent={AnalyticsEnum.LABORATORY_PROFILE_CLICK_ABOUT_PLACE}
            />
          </EntitySection>
        </>
      )}

      {(hasStructure || hasGalleryImages) && (
        <>
          <EntitySectionDivider />

          {hasStructure && (
            <EntitySection
              data-testid={DataTestIdEnum.LABORATORY_PROFILE_SECTION_STRUCTURE}
              title="Estrutura"
              id="structure"
              className="my-0 py-4"
              titleStyles="mb-4 leading-6"
              removeHr
            >
              <BranchLaboratoryStructure structure={{
                airConditioning: structure?.airConditioning || false,
                elevator: structure?.elevator || false,
                parking: structure?.parking || false,
                specialAccess: structure?.specialAccess || false,
              }}
              />
            </EntitySection>
          )}

          {hasGalleryImages && (
            <EntitySection className="my-0 py-4" removeHr>
              <GalleryCarousel
                altText={laboratory.name || ''}
                images={laboratory?.facilityImages as GalleryImage[]}
              />
            </EntitySection>
          )}
        </>
      )}
    </>
  );
}
